import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Row, Col, Button, Table, Form, Card } from 'react-bootstrap';
import Layout from '../../layout/Layout';
import { API } from '../../App';
import Pagination from 'rc-pagination';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie'

var Sr = [];
const UploadData = () => {
    const [data, setdata] = useState([])
    const navigate = useNavigate()
    const [dataLength, setdataLength] = useState(1)
    const [current, setCurrent] = useState(1);
    const [iconcoror, Seticoncoror] = useState("name_up")
    const [perPage, setPerPage] = useState(10);
    const [loading, setLoading] = useState(false)
    const [size, setSize] = useState(perPage);
    const [search, setSearch] = useState({
        name: "",
    })

    const getdata = async (sortdata) => {
        setLoading(true)
        const token = Cookies.get('jwt')
        const res = await API.post("/GetuploadDatas", {}, { headers: { "authorization": `Bearer ${token}` } })
        console.log(res)
        if (res.data.response_code == 0) {
            navigate("/")
        }
        else {
            setdata(res.data.data)
            res.data.data.map((val) => {
                Sr.push(val._id)
            })
            setLoading(false)
        }
    }

    useEffect(() => {
        getdata()
    }, [])


    const SerachData = async (e) => {
        setSearch({ ...search, [e.target.name]: e.target.value })

        const res = await API.post(`/SerchDataupload`, { name: (e.target.name === "name") ? e.target.value : search.name })
        setdata(res.data.data)
        if (res.data.data.length === 0) {
            setdataLength(0)
        } else {
            setdataLength(1)

        }

    }

    const getData = (current, pageSize) => {
        return data.slice((current - 1) * pageSize, current * pageSize);
    };

    const PerPageChange = (value) => {

        setSize(value);

        const newPerPage = Math.ceil(data.length / value);
        if (current > newPerPage) {
            setCurrent(newPerPage);
        }
    }

    const PaginationChange = (page, pageSize) => {
        setCurrent(page);
        setSize(pageSize)
    }


    const PrevNextArrow = (current, type, originalElement) => {
        if (type === 'prev') {
            return <button className='paggination-btn'>Previous</button>;
        }
        if (type === 'next') {
            return <button className='paggination-btn'>Next</button>;
        }
        return originalElement;
    }



    const deleteUser = async (_id) => {

        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger me-3'
            },
            buttonsStyling: false
        })

        swalWithBootstrapButtons.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            reverseButtons: true
        }).then(async (result) => {
            if (result.isConfirmed) {
                const dele = await API.post(`/uploadDatasDel/${_id}`)
                getdata()
            } else if (
                /* Read more about handling dismissals below */
                result.dismiss === Swal.DismissReason.cancel
            ) {

            }
        })

    }

    const sorting = (col, order, e) => {
        Seticoncoror(e.target.id)
        if (order === "ASC") {
            const sorted = [...data].sort((a, b) =>
                a[col] > b[col] ? 1 : -1
            );
            if (iconcoror !== e.target.id) {
                setdata(sorted)
            }
        }
        if (order === "DSC") {
            const sorted = [...data].sort((a, b) =>
                a[col] < b[col] ? 1 : -1
            );
            if (iconcoror !== e.target.id) {
                setdata(sorted)
            }
        }
    }
    return (
        <Layout sidebar={true}>
            <div className="page-heading">
                <h3 className="my-1">Upload Data</h3>
                <Row className="align-items-center">
                    <Col md="auto" xs={12}>
                        <Form.Control type="text" name="name" id="" placeholder="Search Name" className="my-1" onChange={SerachData} />
                    </Col>
                    <Col md="auto" xs={6}>
                        <Form.Select className="my-1" onChange={e => { setSize(Number(e.target.value)); setCurrent(1) }}>
                            {
                                [10, 25, 50, 100].map(pageSize => (
                                    <option key={pageSize} value={pageSize}>
                                        {pageSize}
                                    </option>
                                ))
                            }
                        </Form.Select>
                    </Col>
                    <Col md="auto" xs={12}>
                        <Link to="/uploaddata/add">
                            <Button variant="primary" className='my-1' value="create">Add New</Button>
                        </Link>
                    </Col>
                </Row>
            </div>
            <div className="page-content">
                <Row>
                    <Col xs={12}>
                        <Card>
                            <Card.Body>
                                {
                                    loading ? <div className='loader table-loader' ></div> : <></>
                                }
                                <Table bordered responsive id="myTable">
                                    <thead>
                                        <tr>
                                            <th width="5%" className='text-center'>
                                                {/* <div className='table-sort-filter'> */}
                                                No
                                                {/* <span className='table-sort'> */}
                                                {/* <i className={`bx bxs-up-arrow ${iconcoror === "index_up" ? "active" : ""}`} id="index_up" onClick={(e) => { sorting('index', "ASC", e) }} ></i> */}
                                                {/* <i className={`bx bxs-down-arrow ${iconcoror === "index_down" ? "active" : ""}`} id="index_down" onClick={(e) => { sorting('index', "DSC", e) }} ></i> */}
                                                {/* </span> */}
                                                {/* </div> */}
                                            </th>
                                            <th width="75%">
                                                <div className='table-sort-filter'>
                                                    Name
                                                    {data.length > 1 ?
                                                        <span className='table-sort'>
                                                            <i className={`sort-down ${iconcoror === "name_up" ? "active" : ""}`} id="name_up" onClick={(e) => { sorting('name', "ASC", e) }} ></i>
                                                            <i className={`sort-up ${iconcoror === "name_down" ? "active" : ""}`} id="name_down" onClick={(e) => { sorting('name', "DSC", e) }} ></i>
                                                        </span>
                                                        : ""}
                                                </div>
                                            </th>
                                            <th width="10%" className='text-center'>Zip Link</th>
                                            <th width="10%" className='text-center'>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            getData(current, size).map((val, id) => {
                                                return (
                                                    <tr key={id}>
                                                        <td className='text-center'>{id + 1}</td>
                                                        <td>
                                                            <p className='mb-0 break-word'>{val.name}</p>
                                                        </td>
                                                        <td className='text-center'>
                                                            <a download="GFG" href={val.zip_name}>
                                                                <Button variant="outline-primary" size="sm" className="me-2 btn-icon Zip-downlode-btn"><i className='bx bxs-download'></i></Button>
                                                            </a>
                                                        </td>
                                                        <td className='text-center'>
                                                            <Link to={`/uploaddata/view/${val._id}`}>
                                                                <Button variant="outline-warning" size="sm" className="me-2 btn-icon"><i className='bx bx-show'></i></Button>
                                                            </Link>

                                                            <Button variant="outline-danger" size="sm" className="btn-icon"><i className='bx bx-trash-alt' onClick={() => deleteUser(val._id)}></i></Button>

                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                    {
                                        dataLength === 0 ? <tr>
                                            <td colSpan="100%" className="p-0">
                                                <div className='no-found'>
                                                    <img src="../../not-found/upload-data.svg" />
                                                    <p>No Found UploadData List</p>
                                                </div>
                                            </td>
                                        </tr> : ""
                                    }
                                </Table>
                                {(data.length > size) ?
                                    <div className="pagination-custom">
                                        <Pagination
                                            className="pagination-data"
                                            onChange={PaginationChange}
                                            total={data.length}
                                            current={current}
                                            // showLessItems={wSize<575?true:false}
                                            pageSize={size}
                                            showSizeChanger={false}
                                            itemRender={PrevNextArrow}
                                            onShowSizeChange={PerPageChange}
                                            showTitle={false}
                                        />
                                    </div> : ""}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        </Layout>
    )
}

export default UploadData